import axios from "axios";
import $store from "../store";
import $EventBus from "./eventBus";

// axios
let axiosCounter = 0;
const $axios = axios.create({
  timeout: 60000,
  headers: {
    "Content-Type": "application/json",
  },
});
$axios.interceptors.request.use((config) => {
  emitLoading(true);
  // application/json인데 data필드가 비어있으면 서버가 contentType을 빈값으로 인식함
  if (/application\/json/.test(config.headers["Content-Type"]) && !config.data)
    config.data = {};
  
  // IE11 목록갱신 안되는 문제
  if (config.method === "get") {
    if (!config.params) config.params = {};
    config.params._ts = Date.now();
  }
  return config;
});
$axios.interceptors.response.use(
  (res) => {
    emitLoading(false);
    return res;
  },
  (error) => {
    emitLoading(false);
    const msg = _.get(error, "response.data.message") || "";
    const status = _.get(error, "response.status") || "";
    const url = _.get(error, "request.responseURL") || "";
    if (!error.config.skipCommonErrorHandler) {
      if (status === 401) $store.commit("setErrorState", "loginFail");
      else alert(`status : ${status}\nmessage : ${msg}\nurl : ${url}`);
    }
    return Promise.reject(error);
  }
);
function emitLoading(inc) {
  if (inc) {
    if (!axiosCounter) $EventBus.$emit("loading", true);
    axiosCounter++;
  } else {
    axiosCounter--;
    if (!axiosCounter) $EventBus.$emit("loading", false);
  }
}

export default $axios;
